import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteTargetsApiCrud,
  type DeleteTargetsRequest,
} from "@/generated/fastapi";

export async function deleteTargets(
  accessToken: string | null | undefined,
  request: DeleteTargetsRequest,
) {
  const response = await deleteTargetsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to delete targets (${response.status})`);
  }

  return response.data;
}
